export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "auth.worker.ea25d9255feae3c6e632.worker.js");
}
